import { render } from "./annoucement.vue?vue&type=template&id=05be167e"
import script from "./annoucement.vue?vue&type=script&lang=js"
export * from "./annoucement.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\discussion-guru\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__